export default {"src":"https://fishbrain.com/_next/static/media/firstPlace.ea650213.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};